import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  // Fix: Stop the body from scrolling when menu is open
  useEffect(() => {
    if (click) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [click]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960) {
        setClick(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <Link to='/' className='navbar-logo-link' onClick={closeMobileMenu}>
          <img src='/logo-transparent-bez-textu.png' alt="Finiš Logo" width="110"/>
        </Link>

        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
              Domov
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/menu' className='nav-links' onClick={closeMobileMenu}>
              Menu
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/gallery' className='nav-links' onClick={closeMobileMenu}>
              Galéria
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/kontakt' className='nav-links' onClick={closeMobileMenu}>
              Kontakt
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;